import React from "react"
import {
    Card,
    CardBody,
    Col,
    Row,
    Button
} from "reactstrap"

const AccountCreate = () => {
    return (
        <div>
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <Row className="mb-3 col-md-7">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-2 col-form-label"
                                >
                                    First Name
                                </label>
                                <div className="col-md-10">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Type here..."
                                    />
                                </div>
                            </Row>
                            <Row className="mb-3 col-md-7">
                                <label
                                    className="col-md-2 col-form-label"
                                    htmlFor="example-search-input"
                                >
                                    Last Name
                                </label>
                                <div className="col-md-10 col-md-7">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Type here..."
                                    />
                                </div>
                            </Row>
                            <Row className="mb-3 col-md-7">
                                <label
                                    htmlFor="example-email-input"
                                    className="col-md-2 col-form-label"
                                >
                                    Email
                                </label>
                                <div className="col-md-10">
                                    <input
                                        className="form-control"
                                        type="email"
                                        placeholder="Type here..."
                                    />
                                </div>
                            </Row>

                            <Row className="mb-3 col-md-7">
                                <label
                                    htmlFor="example-number-input"
                                    className="col-md-2 col-form-label"
                                >
                                    Mobile
                                </label>
                                <div className="col-md-10">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Type here..."
                                        id="example-number-input"
                                    />
                                </div>
                            </Row>

                            <Row className="mb-3 col-md-7">
                                <label className="col-md-2 col-form-label">User Level</label>
                                <div className="col-md-10">
                                    <select className="form-control">
                                        <option>Admin</option>
                                        <option>User</option>
                                        <option>Service Provider</option>
                                    </select>
                                </div>
                            </Row>
                            <Row className="mb-3">
                                <div className="col-md-5"></div>
                                <Button className="btn btn-primary col-md-1" type="submit"> Submit
                                </Button>
                                <div className="col-md-5"></div>
                            </Row>
                        </CardBody>

                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default AccountCreate
